import { useFormikContext } from 'formik';
import { IEhs } from '@relab/alstom-ptw-shared';
import { Grid, Header, Image, Message } from 'semantic-ui-react';
import { TranslationComponent } from '../../../TranslationComponent';
import { TextArea } from 'formik-semantic-ui';
import { InputWithoutEnter } from '../../../InputWithoutEnter';
import { SignContainer } from '../StyledEhsComponents';
import { SignatureModal } from '../SignatureModal';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const EhsPhaseClosureForm = () => {
  const { values, setFieldValue, touched, errors } = useFormikContext<IEhs>();
  const { t } = useTranslation();

  return (
    <>
      <Grid.Row columns={1}>
        <Grid.Column>
          <Header size={'small'}>
            <TranslationComponent stringKey={'Note'} />
          </Header>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns={1}>
        <Grid.Column>
          <TextArea name={'note'} />
        </Grid.Column>
      </Grid.Row>

      <Grid.Row columns={1}>
        <Grid.Column>
          <Header size={'small'}>
            <TranslationComponent stringKey={'Chi riconsegna (Referente attività eseguita)'} />
          </Header>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns={2}>
        <Grid.Column>
          <InputWithoutEnter name={'riconsegnaName'} label={t('Cognome e nome')} />
        </Grid.Column>
        <Grid.Column>
          <SignContainer>
            {touched.riconsegnaSign && errors.riconsegnaSign ? (
              <Message error visible content={errors.riconsegnaSign} />
            ) : (
              <Image src={values.riconsegnaSign} />
            )}
            <SignatureModal onSignature={(signature) => setFieldValue('riconsegnaSign', signature)} />
          </SignContainer>
        </Grid.Column>
      </Grid.Row>

      <Grid.Row columns={1}>
        <Grid.Column>
          <Header size={'small'}>
            <TranslationComponent stringKey={'Chi prende in consegna (Referente ALSTOM / Altro)'} />{' '}
          </Header>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns={2}>
        <Grid.Column>
          <InputWithoutEnter name={'prendeInConsegnaName'} label={t('Cognome e nome')} />
        </Grid.Column>
        <Grid.Column>
          <SignContainer>
            {touched.prendeInConsegnaSign && errors.prendeInConsegnaSign ? (
              <Message error visible content={errors.prendeInConsegnaSign} />
            ) : (
              <Image src={values.prendeInConsegnaSign} />
            )}
            <SignatureModal onSignature={(signature) => setFieldValue('prendeInConsegnaSign', signature)} />
          </SignContainer>
        </Grid.Column>
      </Grid.Row>

      <Grid.Row columns={1}>
        <Grid.Column>
          <Header size={'small'}>
            <TranslationComponent stringKey={'Responsabile ALSTOM dell’attività ad alto rischio'} />
          </Header>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns={2}>
        <Grid.Column>
          <InputWithoutEnter name={'responsabileAltoRischioName'} label={t('Cognome e nome')} />
        </Grid.Column>
        <Grid.Column>
          <SignContainer>
            {touched.responsabileAltoRischioSign && errors.responsabileAltoRischioSign ? (
              <Message error visible content={errors.responsabileAltoRischioSign} />
            ) : (
              <Image src={values.responsabileAltoRischioSign} />
            )}
            <SignatureModal onSignature={(signature) => setFieldValue('responsabileAltoRischioSign', signature)} />
          </SignContainer>
        </Grid.Column>
      </Grid.Row>
    </>
  );
};
